import { createFileRoute } from '@tanstack/react-router';
import { GiftCardRedemptionsPage } from './GiftCardRedemptionsPage';

export const Route = createFileRoute('/_protected/admin/internal-tools/gift-card-redemptions/')({
  component: GiftCardRedemptionsPage,
});
